// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__3FzkG","tab":"Tabs_tab__1vwe_","tab--active":"Tabs_tab--active__3iJVv"};